import React from "react";
import SelectBox from "../../central/SelectBox";

const GK_ICON = " 🧤";

export default function AppearanceStep({ players = [], appearanceData = {}, setAppearanceData, leagueType, onNext, availablePlayerIDs = null }) {
  let numericLeagueType = 7;
  if (typeof leagueType === "string") {
    const match = leagueType.match(/\d+/);
    if (match) numericLeagueType = parseInt(match[0], 10);
  } else {
    numericLeagueType = leagueType;
  }

  const numAppeared = Object.values(appearanceData).filter((d) => d?.appeared).length;

  const toggleAppearance = (playerId, appeared) => {
    setAppearanceData((prev) => {
      const alreadyAppeared = prev[playerId]?.appeared;
      return {
        ...prev,
        [playerId]: {
          ...prev[playerId],
          appeared: !!appeared,
          isGK: appeared ? prev[playerId]?.isGK || false : false,
        },
      };
    });
  };

  const toggleGK = (playerId) => {
    setAppearanceData((prev) => {
      const updated = {};
      const isSame = prev[playerId]?.isGK === true;

      Object.keys(prev).forEach((id) => {
        updated[id] = {
          ...prev[id],
          isGK: id === playerId ? !isSame : false,
        };
      });

      return updated;
    });
  };

  const someoneIsGK = Object.values(appearanceData).some((d) => d?.appeared && d?.isGK);


  return (
    <div>
      <div
        style={{
          fontStyle: "italic",
          marginBottom: 8,
          fontSize: "0.9em",
        }}
      >
        <strong>Tap a player</strong> to mark them as appeared
        <br />
        Mark one defender as GK using 🧤
      </div>
      {players.map((p) => {
        const data = appearanceData[p.id] || { appeared: false, isGK: false };

        return (
          <SelectBox
            key={p.id}
            selected={appearanceData[p.id]?.appeared}
            onClick={() => toggleAppearance(p.id, !data.appeared)}
          >
            <div style={{ display: "flex", alignItems: "center", userSelect: "none"}}>
              <span>{p.name} ({p.position})</span>
              {availablePlayerIDs?.has(p.id) && (
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#4CAF50",
                    display: "inline-block",
                    flexShrink: 0,
                    marginLeft: 8,
                  }}
                  aria-label="Available"
                  title="Marked available"
                />
              )}
              {p.position === "DEF" && data.appeared && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!data.isGK && someoneIsGK) return;
                    toggleGK(p.id);
                  }}
                  style={{
                    marginLeft: "1rem",
                    cursor: data.isGK || !someoneIsGK ? "pointer" : "default",
                    color: !data.isGK && someoneIsGK ? "#aaa" : "inherit",
                    userSelect: "none",
                  }}
                >
                  Goalkeeper{GK_ICON}
                </span>
              )}
            </div>
          </SelectBox>
        );
      })}
    </div>
  );
}